import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dataMomento'
})
export class DataMomentoPipe implements PipeTransform {

  
  transform(value: any, args?: any): any {
    let moment = require('moment');

    return moment(value).format('DD/MM/YYYY');
  }

}
